import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useCampaignClone } from '../api';
import { ComposeWizard } from '../components/ComposeWizard';
import { hydrateFromClonePayload } from '../hydrate';

export function UpdateVoiceCampaignPage() {
  const { campaignId } = useParams<{ campaignId: string }>();
  const id = Number(campaignId);
  const clone = useCampaignClone(id);

  const initial = useMemo(
    () => (clone.data ? hydrateFromClonePayload(clone.data) : undefined),
    [clone.data],
  );

  if (clone.isLoading || !initial) {
    return (
      <div className="flex h-full items-center justify-center gap-2 text-muted-foreground">
        <Loader2 className="h-5 w-5 animate-spin" />
        Loading campaign…
      </div>
    );
  }

  return (
    <ComposeWizard
      mode="update"
      campaignId={id}
      initialValues={initial}
      pageTitle={`Edit Campaign #${id}`}
      pageDescription="Make changes to a scheduled or ready campaign."
    />
  );
}
